/**
 * @description 404 page
 */
import React from 'react'

export default function Page404() {
  return (
    <div id="404-page" className="flex h-full flex-col items-center justify-center">
      <h1>404 Not Found</h1>
      <p>无法找到页面，请换一个 URL 重试</p>
    </div>
  )
}
